import { render, staticRenderFns } from "./statusManage.vue?vue&type=template&id=47d928da"
import script from "./statusManage.vue?vue&type=script&lang=js"
export * from "./statusManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports